import axios from 'lib/axios'

export const createQuestionnaireRequestAttachment = (questionnaireRequestHashedId, fileSandboxId, position) => {
  const data = {
    questionnaire_request: {
      file_sandbox_id: fileSandboxId,
      position,
    },
  }
  return axios.post(`/questionnaire_requests/${questionnaireRequestHashedId}/upload_questionnaire_pdf`, data)
}

export const removeQuestionnaireRequestAttachment = (questionnaireRequestHashedId, attachmentId) => {
  return axios.delete(
    `/questionnaire_requests/${questionnaireRequestHashedId}/delete_questionnaire_pdf/${attachmentId}`
  )
}
